import { PAGES } from '@/constants/pages';

export default {
  updateReports(state, data) {
    state.reports = data;
  },

  /**
   *
   * @param state
   * @param type
   * @param data
   */
  updateReportsSelling(state, {type, data}) {
    if (type === 'zgi') {
      state.reportsSellingZgi = data
    } else if (type === 'cut') {
      state.reportsSellingCut = data
    } else {
      state.reportsSellingOpt = data
    }
  },

  /**
   *
   * @param state
   * @param type
   * @param data
   */
  updateReportsOrders(state, {type, data}) {
    if (type === 'from_dealers') {
      state.reportsOrdersFromDealers = data.data
      state.reportsOrdersFromDealersHeaders = data.header
      state.reportsOrdersFromDealersTotal = data.total
    } else if (type === 'to_supplier') {
      state.reportsOrdersToSupplier = data.data
      state.reportsOrdersToSupplierHeaders = data.header
    } else {
      state.reportsOrdersRetail = data.data
      state.reportsOrdersRetailHeaders = data.header
    }
  },

  updateServices(state, data) {
    state.services = data;
  },

  setNeedOpenModal(state, id) {
    state.needOpenModal = id
  },

  setLoading(state, value) {
    state.loading = value
  },

  setLoadingInPopup(state, value) {
    state.loadingInPopup = value
  },

  switchOnEditMode(state, field) {
    state.editMode = true
    state.editField = field
  },

  switchOffEditMode(state) {
    state.editMode = false
    state.editField = ''
  },

  updateNotifications(state, data) {
    state.notifications = data;
  },

  updateNotificationsRead(state, index) {
    state.notifications.data[index].viewed = 1;
  },

  toggleEditMode(state, field) {
    if (state.editField === field) {
      state.editMode = !state.editMode
    } else {
      state.editMode = true
      state.editField = field
    }
  },

  // ============Страница "Профиль"============
  setCurrencies(state, list) {
    state.currencies = list.map((item, i, array) => {
      return {
        value: item.id,
        name: item.name,
      }
    })
  },

  updateProfileBalance(state, data) {
    state.profileBalance = data;
  },


  updateProfileInvoices(state, data) {
    state.profileInvoices = data;
  },

  updateProfileShippings(state, data) {
    state.profileShippings = data;
  },

  // ============Страница "Сотрудники"============

  setEmployees(state, value) {
    state.employees = value
  },

  /**
   *
   * @param state
   * @param value
   */
  addEmptyEmployee(state, value) {
    state.employees.unshift(value);
  },

  updateEmployeeInfo(state, {id, data}) {
    const index = state.employees.findIndex(e => e.id === id)

    if (index >= 0) {
      for (let key in data) {
        state.employees[index][key] = data[key];
      }
    }
  },

  setSelectedEmployee(state, value) {
    state.selectedEmployee = value
  },

  updateSortMap(state, {table, field}) {
    let curTable = state.sortMap[table]
    const newSort = (curTable[field] === 'asc') ? 'desc' : 'asc'
    state.sortMap[table][field] = newSort
    state.sortMap = {...state.sortMap}
  },

  updateDealer(state, {dealerIndex, prop, value}) {
    state.dealers[dealerIndex].prop = value
  },

  // ============Страница "Список заказов"============

  setOrders(state, orders) {
    state.ordersAll = orders
    state.ordersB2C = orders.filter(o => o.type_order === 'R')
    state.ordersB2B = orders.filter(o => o.type_order === 'D')
    state.ordersExternal = orders.filter(o => o.type_order === 'S')
  },

  toggleAllExternalOrders(state, value) {
    state.ordersExternal.forEach(o => {
      o.selected = value
    })
  },

  setOrderStatuses(state, statuses) {
    // TODO:: Возможно нужно будет убрать
    state.orderStatuses = statuses
  },

  setOrderStatusList(state, list) {
    state.orderStatusList = list
  },

  setSelectedOrder(state, order) {
    state.selectedOrder = order
  },

  // ============Страница "Розничные цены"============
  setMarkups(state, value) {
    state.markups = value
  },

  changeMarkup(state, {cell, indexes}) {
    if (!cell.isGeneralMargin) {
      return
    }

    state.markups[indexes.typeIndex].list[indexes.modelIndex].cell = state.markups[indexes.typeIndex].list[indexes.modelIndex].cell.map((c, i, arr) => {
      if (i !== 0) {
        c.info = cell.info
      }
      return c
    })
  },

  updateNavigation(state, data) {
    let menu = state.navigation;
    const user = data.user;
    const access = data.access;

    // name - точно не уникальный
    const hideMenuItem = (name, link) => {
      menu.forEach((item, i) => {
        if (link ? item.link === link : item.name === name) {
          return menu.splice(i, 1);
        } else if (item.items && item.items.length) {
          const index = item.items.findIndex(el => (link ? el.link === link : el.name === name));
          if (index !== -1) {
            return item.items.splice(index, 1);
          }
        }
      });
    };

    // удаляем дилеры
    if (!user.dealer.has_sub_dealers || !access.dealers.dealers_list) {
      hideMenuItem(PAGES.dealers.title);
    }

    if (!user.dealer.parent_dealer) {
      //удляем заказы от поставщиков
      hideMenuItem(PAGES.orders.supplier.title);
      //удаляем создание новго заказа
      hideMenuItem(PAGES.orders.new_order.title);
    }

    //удаляем заказы - новый заказ
    if (!access.new_order_to_supplier.supplier_new_order_opt && !access.new_order_to_supplier.supplier_new_order_zgi) {
      hideMenuItem(PAGES.orders.new_order.title);
    }

    //удаляем заказы - заказ поставщику
    if (!access.orders.suppliers.orders) {
      hideMenuItem(PAGES.orders.supplier.title);
    }

    //удаляем заказы - розничные заказы
    if (!access.orders.retails.orders) {
      hideMenuItem(PAGES.orders.retail.title);
    }

    //удаляем заказы - заказы дилеру
    if (!access.orders.dealers.orders || !user.dealer.has_sub_dealers) {
      hideMenuItem(PAGES.orders.dealer.title);
    }

    //удаляем вкладку отчет баланс
    if (!access.reports.balance_request.main || user.dealer.parent_id !== 1) {
      hideMenuItem(PAGES.balance.title);
    }

    //удаляем вкладку - Спеццены и акции
    if (
      !access.reports.report_special_prices.main ||
      user.dealer.level > 1 ||
      user.hide_price !== 0
    ) {
      hideMenuItem(PAGES.special_prices.title);
    }

    //удаляем вкладку список РНК
    if (!access.reports.invoices_request.main || user.dealer.parent_id !== 1) {
      hideMenuItem(PAGES.invoices.title);
    }

    // Скрываем пункт меню "Отчет по товарам"
    if (!access.reports.sales_report.main) {
      hideMenuItem(PAGES.reports.title);
    }

    // Скрываем пункт меню "Отчет по продажам"
    if (!access.reports.report_selling.main || !user.dealer.has_sub_dealers || user.hide_price) {
      hideMenuItem(PAGES.report_selling.title);
    }

    // Скрываем пункт меню "Отчет по заказам"
    if (!access.reports.report_orders.main || user.hide_price) {
      hideMenuItem(null, PAGES.reports_orders.path)
    }

    if (!access.reports.report_by_materials_zgi.main) {
      hideMenuItem(PAGES.reports_by_materials_zgi.title)
    }
    // удаление пункт меню "Отгрузки"
    if (!access.reports.report_shippings.main) {
      hideMenuItem(PAGES.shippings.title)
    }

    //удаление настройки розничные цены
    if (!access.pricings.main) {
      hideMenuItem('Розничные наценки');
    }

    //удаляем найстроки доступы
    if (!access.access_rights.main) {
      hideMenuItem('Права доступа');
    }

    //удаляем настройки сотрудники
    if (!access.employees.main) {
      hideMenuItem(PAGES.employees.title);
    }

    //удялем сроки производства
    if (!access.warehouse.availability && !access.warehouse.production) {
      hideMenuItem(PAGES.warehouse.title);
    }

    //удаляем найстройки - плательщики
    if (!access.dealer_companies.main) {
      hideMenuItem(PAGES.payers.title);
    }

    //удаляем настройки - профиль компании
    if (!access.profile_company.main) {
      hideMenuItem(PAGES.profile.title);
    }

    if (!access.reclamations.main || !user.dealer.has_sub_dealers) {
      hideMenuItem(PAGES.reclamations_dealers.title);
    }

    if (!access.reclamations.main || !user.dealer.parent_dealer) {
      hideMenuItem(PAGES.reclamations_supplier.title);
    }

    //удаляем фотогалерею
    if (user.dealer.level >= 2) {
      hideMenuItem(PAGES.photoGallery.title)
    }

    // удаляем уведомления
    if (!access.notifications.main) {
      hideMenuItem(PAGES.notifications.title);
    }

    let i = menu.length;
    while (i--) {
      if (menu[i].items && !menu[i].items.length) {
        menu.splice(i, 1)
      }
    }

    if (menu.length > 0) {
      menu.push({});
    }
  },

  changeAllMarkups(state, totalMarkup) {
    state.markups.forEach(m => {
      Object.keys(m.list).map(key => {
        m.list[key].cell.forEach((c, cIndex, cArr) => {
          if (c.info) {
            c.info = totalMarkup
          }
        })
      })
    })
  },
}
